module.exports = __webpack_public_path__ + "img/usedGenerated.4a4297d6.png";